// extracted by mini-css-extract-plugin
export default {"paper":"TopDeals_paper__7kHzX"};